import { Injectable } from "@angular/core";
import { LocationGroupMapper } from "./location-group.mapper";
import { CrudAbstractRepository } from "../crud-abstract/crud-abstract.repository";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { LocationGroup } from "./location-group.model";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import { PaginatedResponse } from "app/shared/http/paginated-response.model";

@Injectable()
export class LocationGroupRepository extends CrudAbstractRepository {
  getMapper(): any {
    return LocationGroupMapper.map;
  }

  getEndpoint(): string {
    return "location-group";
  }

  public getByCountry(country: string): Observable<LocationGroup | null> {
    const params = new HttpParams().append("criteria[country]", country);

    return this.http
      .get<PaginatedResponse>(`${environment.apiUrl}/${this.getEndpoint()}`, {
        params: params,
      })
      .pipe(
        map((response) =>
          response.items && response.items.length
            ? LocationGroupMapper.map(response.items[0])
            : null,
        ),
      );
  }

  public search(query: string): Observable<LocationGroup[]> {
    const params = new HttpParams().append("search", query);

    return this.http
      .get<LocationGroup[]>(
        `${environment.apiUrl}/${this.getEndpoint()}/list`,
        {
          params: params,
        },
      )
      .pipe(map((response) => response.map(this.getMapper())));
  }
}
